import React from 'react'
import { isNil, isEmpty, equals, length, keys, __, compose } from 'ramda'

type Props<T> = { item?: T | null; onEdit?: (isEdit: boolean) => void }

export function useEdit<T = any>({ item, onEdit }: Props<T> = {}) {
  const isCreate = React.useMemo(
    () =>
      isNil(item) ||
      isEmpty(item) ||
      compose(equals(__, 0), length, keys)(item),
    [item]
  )
  const [isEdit, setIsEdit] = React.useState(isCreate)

  let isInit = React.useRef(false)

  React.useEffect(() => {
    if (item && !isInit.current) {
      setIsEdit(false)
      isInit.current = true
    }
  }, [item])

  React.useEffect(() => {
    setIsEdit(isCreate)
  }, [isCreate])

  const handleEdit = () => {
    if (onEdit) {
      onEdit(!isEdit)
    }

    setIsEdit(prevIsEdit => !prevIsEdit)
  }

  return {
    isCreate,
    isEdit,
    handleEdit,
    setIsEdit,
  }
}

export default useEdit
